/* Minimal, dependency-free fallback shell — deliberately plain CSS
 * values (no design-token `var(--...)` refs). This is the last-resort
 * render path when something in the tree below it has already thrown,
 * so it must not lean on any shared styling machinery that could itself
 * be implicated in a broken build. */
.fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 100%;
  min-height: 200px;
  padding: 24px;
  text-align: center;
}

.retryButton {
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background: #2563eb;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.retryButton:hover {
  background: #1d4ed8;
}
